import { MagicConfigMixin, RoutablePage } from '@gig/magic-common';
import { Mixins, Prop, Watch, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { FAQ_NAMESPACE } from '../../store/modules/faq/faq.store.js';
import { store } from '../../store/index.js';
import { createFaqSearch } from '../../util/faq-search.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const faqModule = namespace(FAQ_NAMESPACE);
let FaqSearchComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.searchResults = [];
  }
  get hasSearchResults() {
    return this.searchResults.length > 0;
  }
  fetchFAQData() {
    return __async(this, null, function* () {
      try {
        yield this.fetchEntries(this.magicConfig.language);
      } catch (e) {
        this.routeTo({ route: RoutablePage.NOT_FOUND });
        console.error(e);
      }
    });
  }
  rebuildSearch() {
    if (!this.entries) {
      return;
    }
    this.searchFaqs = createFaqSearch(this.entries);
  }
  getSearchResults() {
    const query = this.query.trim().toLowerCase();
    if (query.length < this.minLength || !this.searchFaqs) {
      this.searchResults = [];
      return;
    }
    this.searchResults = this.searchFaqs(query, this.limit);
  }
};
__decorateClass([
  Prop({ type: String, default: "" })
], FaqSearchComponent.prototype, "query", 2);
__decorateClass([
  Prop({ type: Number, default: 0 })
], FaqSearchComponent.prototype, "minLength", 2);
__decorateClass([
  Prop({ type: Number, default: 100 })
], FaqSearchComponent.prototype, "limit", 2);
__decorateClass([
  faqModule.Action("fetchEntries")
], FaqSearchComponent.prototype, "fetchEntries", 2);
__decorateClass([
  faqModule.Getter("isLoading")
], FaqSearchComponent.prototype, "isLoading", 2);
__decorateClass([
  faqModule.Getter("entries")
], FaqSearchComponent.prototype, "entries", 2);
__decorateClass([
  Watch("magicConfig.language", { immediate: true })
], FaqSearchComponent.prototype, "fetchFAQData", 1);
__decorateClass([
  Watch("entries", { immediate: true })
], FaqSearchComponent.prototype, "rebuildSearch", 1);
__decorateClass([
  Watch("query", { immediate: true }),
  Watch("entries")
], FaqSearchComponent.prototype, "getSearchResults", 1);
FaqSearchComponent = __decorateClass([
  Component({
    name: "faq-search",
    store
  })
], FaqSearchComponent);

export default FaqSearchComponent;
